import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"
import { SectionGateVerdict } from "../types/types"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.communitySectionsAvailability
)

export const selectCommunitySectionsAvailabilityStatus = createSelector(
    baseSelector,
    (state) => state.status
)

export const selectCommunitySectionsAvailabilityError = createSelector(
    baseSelector,
    (state) => state.error
)

export const selectLoyaltyLevelsGate = createSelector(
    baseSelector,
    (state): SectionGateVerdict => {
        if (state.status === "loading") {
            return { status: "loading", reason: null }
        }

        if (state.status === "idle" || state.status === "failed" || !state.data) {
            return { status: "unknown", reason: state.error?.message || null }
        }

        const availability = state.data.loyalty_levels

        if (availability.status === "unknown") {
            return { status: "unknown", reason: availability.reason }
        }

        return {
            status: availability.is_enabled === true ? "available" : "disabled",
            reason: availability.reason,
        }
    }
)

export const selectRestaurantMenusGate = createSelector(
    baseSelector,
    (state): SectionGateVerdict => {
        if (state.status === "loading") {
            return { status: "loading", reason: null }
        }

        if (state.status === "idle" || state.status === "failed" || !state.data) {
            return { status: "unknown", reason: state.error?.message || null }
        }

        const availability = state.data.restaurant_menus

        if (availability.status === "unknown") {
            return { status: "unknown", reason: availability.reason }
        }

        return {
            status: availability.max_menus > 0 ? "available" : "disabled",
            reason: availability.reason,
        }
    }
)
